import { forkJoin } from 'rxjs';
import { Characteristic } from './../../../../models/interface/product/characteristic';
import { PartyService } from './../../../../services/api/party/party.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Party } from 'src/app/models/party-manager/party';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { Role } from 'src/app/models/party-manager/role';
import { PartyCharacteristic } from 'src/app/models/party-manager/party-characteristic';

@Component({
  selector: 'app-update-party',
  templateUrl: './update-party.component.html',
  styleUrls: ['./update-party.component.scss']
})
export class UpdatePartyComponent implements OnInit {

  party:Party;
  characteristicSpec: PartyCharacteristic[];
  form: FormGroup;

  tooltip = {
    submit: '',
    reset: ''
  };

  roles:Role[];

  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private notificationsService: NotificationsService,
    private partyService:PartyService,
    public dialogRef: MatDialogRef<UpdatePartyComponent>,
     @Inject(MAT_DIALOG_DATA) private data: {
    party: Party;
  },) { }

  ngOnInit() {
    this.party = this.data.party

    forkJoin( this.partyService.getCharacteristicBySpec(this.party.partySpecRef.namingId),this.partyService.getRoles()).subscribe(data =>{
      this.characteristicSpec = data[0];
      this.roles = data[1];
      this.initForm();
    });

    this.initTooltips();
  }

  initForm(){
    this.form = this.formBuilder.group({
      operatorCode: this.formBuilder.control({value:this.party.namingId,disabled: true},Validators.required),
      operatorName: this.formBuilder.control({value:this.party.name,disabled:true},Validators.required),
      operatorSpec: this.formBuilder.control({value: this.party.partySpecRef.name,disabled: true},Validators.required)
    });
    
    for(let characteristic of this.characteristicSpec){
      let characteristicValue =  this.party.describedByList.find(p=> p.partyCharRef.namingId === characteristic.partyCharRef.namingId);
     let value = characteristicValue ? characteristicValue.value: "";
      this.form.addControl(characteristic.partyCharRef.namingId,this.formBuilder.control(value))
    }
   
    let rolesInit:number[] = this.party.allowedRoles.map(rol => rol.id);
    this.form.addControl('roles',this.formBuilder.control(rolesInit));
    
  }



  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
      this.tooltip.reset = this.translate.instant('TOOLTIPS.resetForm');
    });
  }

  clearForm() {
    this.form.reset();
    this.initForm();
  }


  public submitForm() {
    let characteristicsForm:PartyCharacteristic[]=[];
    for(let characteristic of this.characteristicSpec){
      if(this.form.get(characteristic.partyCharRef.namingId).value){
        characteristicsForm.push({
          partyCharRef:{
            name:characteristic.partyCharRef.name, 
            namingId: characteristic.partyCharRef.namingId
          },
          value:this.form.get(characteristic.partyCharRef.namingId).value,
          hjid:characteristic.hjid
        });
      }
    }
    debugger;

    let roles : Role[]=[];
    for(let roleId of this.rolesControl.value){
      let role = this.roles.find(p=> p.id===roleId);
      roles.push(role);
    }
    let party :Party = this.party; 
    party.domain= "ADAMO"
    party.allowedRoles= roles;
    party.describedByList = characteristicsForm;
  
    this.partyService.update(party).subscribe( () => {
      this.notificationsService.showNotification(`El Operador ${this.nameControl.value} se ha actualizado correctamente`, NotificationLevel.SUCCESS);
      this.dialogRef.close();
    },
    (er) => {
      this.notificationsService.showNotification(
        `Ha habido un problema al actualizar el Operador:\n${er.error.error}`, NotificationLevel.ERROR);
    });
  }

  get codeControl(): FormControl {
    return this.form.get('operatorCode') as FormControl;
  }

  get nameControl(): FormControl {
    return this.form.get('operatorName') as FormControl;
  }
  get specRefControl(): FormControl {
    return this.form.get('operatorSpec') as FormControl;
  }

  get rolesControl(): FormControl {
    return this.form.get('roles') as FormControl;
  }

}
